import React from "react";
import Spinner from "../../../../components/presentationals/Spinner";
import Error from "../../../../components/Error";
import CustomCard from "../../../../containers/deviceSales/sales/component/CustomCards";
//import useStyles from '../style';
import TabPanel from "../../../../containers/rechargeSales/sales/component/tabPanel";
function PrimarySalesView(props) {
  let {
    mainHandleChange,
    mainValue,
    salesObj,
    salesCsvLoading,
    data,
    theme,
    body,
    headerUnit,
    updatedData,
    dashboardName,
    viewName,
  } = props;
  return (
    <>
      {salesObj.loading ? (
        <Spinner />
      ) : data ? (
        <>
          <ul className="nav nav-pills tabbtndiv text-center">
            {updatedData?.map((value, index) => {
              return (
                <li key={index}>
                  <a
                    data-toggle="pill"
                    onClick={() => {
                      mainHandleChange(value, index);
                    }}
                    href={`#rsd${index + 1}`}
                    className={mainValue === index ? "active" : ""}
                  >
                    {value[0]}
                  </a>
                </li>
              );
            })}

            {/* {Object.entries(data.salesWrapper).map((value, index) => {
              return (
                <li key={index}>
                  <a
                    data-toggle="pill"
                    onClick={() => {
                      mainHandleChange(value, index);
                    }}
                    href={`#rsd${index + 1}`}
                    className={mainValue === index ? "active" : ""}
                  >
                    {value[0]}
                  </a>
                </li>
              );
            })} */}
          </ul>
          {updatedData?.map((value, index) => {
            return (
              <TabPanel
                key={index}
                value={mainValue}
                index={index}
                dir={theme.direction}
              >
                <CustomCard
                  data={value[1]}
                  tileName={props.tileName}
                  subTileName={value[0]}
                  csvUrl={props.csvUrl}
                  isCsvActive={props.isCsvActive}
                  mainValue={mainValue}
                  filterValue={props.filterValue}
                  body={body}
                  id={props.id}
                  headerSelectedDateFrom={props.startDate}
                  headerSelectedDateTo={props.endDate}
                  headerUnit={headerUnit}
                  salesCsvLoading={salesCsvLoading}
                  dashboardName={dashboardName}
                  viewName={viewName}
                />
              </TabPanel>
            );
          })}
          {/* {Object.entries(data.salesWrapper).map((value, index) => {
            return (
              <TabPanel
                key={index}
                value={mainValue}
                index={index}
                dir={theme.direction}
              >
                <CustomCards
                  data={value[1]}
                  tileName={props.tileName}
                  subTileName={value[0]}
                  csvUrl={props.csvUrl}
                  isCsvActive={props.isCsvActive}
                  mainValue={mainValue}
                  filterValue={props.filterValue}
                  body={body}
                  id={props.id}
                  headerSelectedDateFrom={props.startDate}
                  headerSelectedDateTo={props.endDate}
                  headerUnit={headerUnit}
                  salesCsvLoading={salesCsvLoading}
                />
              </TabPanel>
            );
          })} */}
        </>
      ) : (
        <Error error={salesObj.error} />
      )}
    </>
  );
}

export default PrimarySalesView;
